import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasDatepickerComponent } from './gas-datepicker.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasInputModule } from '../gas-input/gas-input.module';
import { GasClickOutsideDirectiveModule } from '../../utils/click-outside-directive/gas-click-outside.module';
import { GasButtonModule } from './../gas-button/gas-button.module';
import { GasYearComponent } from './gas-year/gas-year.component';
import { GasMonthComponent } from './gas-month/gas-month.component';
import { GasTimeComponent } from './gas-time/gas-time.component';
import { GasDividerModule } from './../../layout/gas-divider/gas-divider.module';

const COMPONENTS = [
  GasDatepickerComponent,
  GasYearComponent,
  GasMonthComponent,
  GasTimeComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  entryComponents: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GasIconsModule,
    GasInputModule,
    GasClickOutsideDirectiveModule,
    GasButtonModule,
    GasDividerModule,
  ],
})
/** @deprecated */
export class GasDatepickerModule { }
